<template lang="pug">
.footer-page
  .contect-icon
    img.weibo-icon(src="../assets/weibo.svg", alt="")
    img(src="../assets/weixin.svg", alt="")
  .support-company
    label Copyright © 2017. All Rights Reserved.上海拓体信息技术有限公司提供技术支持
  .doc 京ICP备14041720号-1京ICP证140622号京公网安备11010502025474
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="stylus" scoped>
.footer-page
  text-align center
  line-height 30px
  padding 15px 0
  background #fff
  font-size 95%
  .contect-icon
    .weibo-icon
      margin-right 30px

@media print
  .footer-page
    display none
</style>



// WEBPACK FOOTER //
// Footer.vue?100507bc